const makeTeamBasicViewData = (services) => {
  const returnDefaultPermissionData = {};

  Object.keys(services).forEach((serviceId) => {
    const servicePermission = {
      // checkTag: [],
      checkTag: '',
      tags: {},
      domainList: [],
      selectedPermissionsByTag: [],
      permissionList: [],
    };
    const tags = servicePermission.tags;
    const domainList = servicePermission.domainList;
    const rageGroup = services[serviceId].range_group;
    const rangTags = services[serviceId].rang_tags;

    rangTags.forEach((tagName, index) => {
      tags[tagName] = [];
      Object.keys(rageGroup).forEach((domainId) => {
        if (index === 0) {
          domainList.push(domainId);
        }
        if (
          rageGroup[domainId].tag.includes(tagName) &&
          !tags[tagName].includes(domainId)
        ) {
          tags[tagName].push(domainId);
        }
      });
    });
    returnDefaultPermissionData[serviceId] = servicePermission;
  });
  return returnDefaultPermissionData;
};

const setTeamView = (team, services) => {
  const returnTeam = JSON.parse(JSON.stringify(team));
  const teamPermissions = returnTeam.permissions;
  const teamViewData = makeTeamBasicViewData(services);
  const division = [];

  Object.keys(teamViewData).forEach((serviceId) => {
    const permissionList = [];
    const selectedPermissionsByTag = [];
    // const checkTag = [];
    let checkTag = '';

    if (!{}.hasOwnProperty.call(teamPermissions, serviceId)) {
      teamPermissions[serviceId] = [];
    }
    teamPermissions[serviceId].forEach((item) => {
      const splitItem = item.split(':');

      if (Array.isArray(splitItem) && splitItem[0] === 'tag') {
        const tagElement = splitItem[1];

        // checkTag.push(tagElement);
        checkTag = tagElement;
        if (Object.keys(teamViewData[serviceId].tags).includes(tagElement)) {
          teamViewData[serviceId].tags[tagElement].forEach((tagDomain) => {
            permissionList.push(tagDomain);
            selectedPermissionsByTag.push(tagDomain);
            if (!division.includes(tagDomain)) {
              division.push(tagDomain);
            }
          });
        }
      } else {
        permissionList.push(splitItem[0]);
        if (!division.includes(splitItem[0])) {
          division.push(splitItem[0]);
        }
      }
    });
    teamViewData[serviceId].checkTag = checkTag;
    teamViewData[serviceId].permissionList = [...new Set(permissionList)];
    teamViewData[serviceId].selectedPermissionsByTag = [...new Set(selectedPermissionsByTag)];
  });
  returnTeam.division = division;
  returnTeam.viewData = teamViewData;
  return returnTeam;
};

const getPartsListByRange = (services, currentTeam) => {
  const parts = [];

  Object.keys(services).forEach((serviceId) => {
    if (currentTeam.available_services.includes(serviceId)) {
      Object.keys(services[serviceId].range_group).forEach((itemId) => {
        services[serviceId].range_group[itemId].tag.forEach((tag) => {
          if (!parts.includes(tag)) {
            parts.push(tag);
          }
        });
      });
    }
  });
  return parts;
};

export default {
  setTeamView,
  getPartsListByRange,
};



// WEBPACK FOOTER //
// ./src/filters/getTeamViewData.js